// extracted by mini-css-extract-plugin
export var accessibilityalert = "SuccessStoriesCarousel-module--accessibilityalert--61137";
export var carouselcontainer = "SuccessStoriesCarousel-module--carouselcontainer--0c3d1";
export var pagination = "SuccessStoriesCarousel-module--pagination--a7743";